var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCertifcate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.23,
    height: 47.23,
    viewBox: "0 0 47.23 47.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "uploadCertifcate",
    d: "M53.254,29.639H35.52V11.905a2.94,2.94,0,1,0-5.881,0V29.639H11.905a2.94,2.94,0,0,0,0,5.881H29.639V53.254a2.94,2.94,0,1,0,5.881,0V35.52H53.254a2.94,2.94,0,1,0,0-5.881Z",
    transform: "translate(-8.965 -8.965)",
    fill: "#5e2b97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCertifcate);
export default __webpack_public_path__ + "static/media/uploadCertifcate.e0f90993873ac726cd4d8eda1d4853ec.svg";
export { ForwardRef as ReactComponent };